import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgWarningAlt = function SvgWarningAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M23.377 16.992L15.456 3.07c-.75-1.36-2.11-2.015-3.47-2.015-1.359 0-2.718.656-3.468 2.015L.596 16.992c-1.5 2.672.422 5.953 3.469 5.953h15.89c3.047 0 4.97-3.328 3.422-5.953zm-1.734 2.953c-.188.282-.703.985-1.734.985H4.065c-1.031 0-1.547-.703-1.734-.985-.188-.28-.516-1.078 0-1.968l7.921-13.875c.516-.891 1.36-.985 1.735-.985s1.219.094 1.734.985l7.922 13.875c.516.89.188 1.687 0 1.968z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M11.987 7.008a.99.99 0 00-.985.984v6a.99.99 0 00.985.985c.515 0 .984-.47.984-.985v-6a.961.961 0 00-.984-.984zM11.987 19.43a1.453 1.453 0 100-2.906 1.453 1.453 0 000 2.906z"
  }));
};

export default SvgWarningAlt;